import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import {
  SingleSelectDropdown,
  SingleSelectDropdownItem,
  DROPDOWN_TYPE
} from "widgets/singleselect";
import { LookupCard } from "widgets/inputs";

import { Base } from "../base";

import styles from "./lookup.css";

function isEmpty(obj) {
  return !obj || Object.keys(obj).length === 0;
}

export function Lookup(props) {
  const { column, value, pos, row } = props;
  const baseRef = useRef(null);
  const selectRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(
    isEmpty(value) ? null : value
  );
  // const [dataSource, setDataSource] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(
    function onValueChange() {
      setCurrentValue(isEmpty(value) ? null : value);
      // setDataSource([]);
      setIsOpen(false);
      // selectRef.current && selectRef.current.blur();
    },
    [value, row, pos]
  );

  const fetchData = (value, row) => {
    return (pageNo = 1, queryStr = "") =>
      column.dataSource({ value, row, pageNo, queryStr });
  };

  return (
    <Base {...props} ref={baseRef} onEditing={(e) => {}} type="select">
      {!isEmpty(currentValue) ? (
        <LookupCard
          columns={column.fields}
          option={value || {}}
          showClearIcon={!column.readOnly}
          onClear={(e) => {
            e.stopPropagation();
            baseRef.current.startEditing(null);
            baseRef.current.dataChanged(null);
            baseRef.current.dataCompleted();
            setCurrentValue(null);
          }}
          actionPath={column.actionPath}
          cellWidth={column?.width}
          hiddenFields={column.hiddenFields}
          scrollable={true}
          scrollableHeight="15.5rem"
          focusOnMount={true}
          columnLayout={column.columnLayout}
        />
      ) : (
        <SingleSelectDropdown
          value={currentValue}
          // dataSource={dataSource}
          dataSource={fetchData(value, row)}
          isOpen={isOpen}
          readOnly={column.readOnly}
          itemRenderer={(value) => {
            return (
              <SingleSelectDropdownItem label="Name" value={value}>
                <LookupCard
                  columns={column.fields}
                  option={value}
                  actionPath={column.actionPath}
                  isDropDownCard={true}
                  cellWidth={column.width}
                  hiddenFields={column.hiddenFields}
                  className={styles.lookupDropdownItem}
                  columnLayout={column.columnLayout}
                />
              </SingleSelectDropdownItem>
            );
          }}
          valueComparer={(a, b) => a._id === b._id}
          onOpen={({ loadDataSource }) => {
            baseRef.current.startEditing(currentValue);
            loadDataSource();
            selectRef.current.focus();
            // column.dataSource({ value, row }).then((dataSource) => {
            //   setDataSource(dataSource && (dataSource.Data || dataSource));
            //   selectRef.current.focus();
            //   setIsOpen(true);
            // });
          }}
          onSearch={({ search }) =>
            column.onSearch({ search, value: currentValue, row, column })
          }
          ref={selectRef}
          onChange={(value) => {
            baseRef.current.dataChanged(value);
            baseRef.current.dataCompleted();
          }}
          type={DROPDOWN_TYPE.MINIMAL}
          dropdownClassName={styles.lookupDropdown}
          className={styles.lookupEditor}
          defer={true}
        />
      )}
    </Base>
  );
}

Lookup.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  pos: PropTypes.any,
  row: PropTypes.any
};
